import { Controller } from "@hotwired/stimulus"

// Instant name filter for the /apps library. Purely client-side over rows
// the server already rendered (the whole visible catalog is on the page), so
// typing narrows without a round trip. Group counts are rewritten as rows hide
// and an emptied group disappears, so no header ever claims more than it shows.
//
// Collapsing the library sidebar is not this controller's job: the shared
// sidebar-collapse controller rides the same .appslib element (see apps/index).
export default class extends Controller {
    static targets = ["query", "row", "group", "noResults"]

    connect() {
        this.filter()
    }

    filter() {
        const needle = (this.hasQueryTarget ? this.queryTarget.value : "").trim().toLowerCase()
        let visible = 0

        this.rowTargets.forEach((row) => {
            const match = needle === "" || (row.dataset.appslibName || "").includes(needle)
            row.hidden = !match
            if (match) visible += 1
        })

        this.groupTargets.forEach((group) => {
            const rows = Array.from(group.querySelectorAll("[data-apps-library-target='row']"))
            const shown = rows.filter((row) => !row.hidden).length
            const count = group.querySelector("[data-appslib-count]")
            if (count) count.textContent = shown
            group.hidden = shown === 0
        })

        if (this.hasNoResultsTarget) {
            this.noResultsTarget.hidden = visible > 0 || this.rowTargets.length === 0
        }
    }
}
